import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "nestedValue",
    pure: false,
    standalone: false,
})
export class NestedValuePipe implements PipeTransform {
    transform(obj: any, path: string): any {
        if (path === "") return obj;
        const val = path.split(".").reduce((acc, part) => acc && acc[part], obj);
        return val ?? "";
    }
}
